// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/load-securing-and-floor-limits.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/load-securing-and-floor-limits/load-securing-and-floor-limits.js';

mount([g0]);
